let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3WAnL")).then(() => parcelRequire('6RGe9'));